var getViewFieldsXml = function (fields) {
    var viewFieldXmls = fields.map(function (field) {
        return "<FieldRef Name=\"" + field + "\"/>";
    });
    return "<ViewFields>" + viewFieldXmls.join('') + "</ViewFields>";
};
export default getViewFieldsXml;
